import {
  AddToGalleryForm,
  ADD_TO_GALLERY_FORM_KEY,
  Discover,
  UPLOAD_MEDIA_FIELD,
} from 'model';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import { selectDiscoverBySlug } from 'redux/modules/discover';
import { getUserGallery } from 'redux/modules/users';
import { addVote, removeVote } from 'redux/modules/vote';
import { makeFormSelectors } from 'utils/makeFormSelectors';
import { openConfirmationModal } from 'utils/openConfirmationModal';
import { useActions } from 'utils/useActions';
import { Props } from './types';

const { selectValues } = makeFormSelectors<AddToGalleryForm>(
  ADD_TO_GALLERY_FORM_KEY,
);

export const useConnect = ({ user }: { user: Props['user'] }) => {
  const { push } = useHistory();
  const { search, state } = useLocation();
  const { params, path, url } = useRouteMatch<{ userSlug?: string }>();

  const addToGalleryValues = useSelector(selectValues);
  const discoverBySlug = useSelector(selectDiscoverBySlug);

  const actions = useActions({
    openConfirmationModal,
    addVote: addVote.request,
    getUserGallery: getUserGallery.request,
    removeVote: removeVote.request,
  });

  return {
    ...actions,
    params,
    path,
    push,
    search,
    state,
    url,
    addToGalleryImages: addToGalleryValues
      ? addToGalleryValues[UPLOAD_MEDIA_FIELD].length
      : 0,
    loading: user ? user.gallerySlugs.loading : false,
    pageCount: user ? user.gallerySlugs.pageCount : 0,
    items: user
      ? (user.gallerySlugs.slugs
          .map((slug) => discoverBySlug[slug])
          .filter((it): it is NonNullable<typeof it> => !!it) as Discover[])
      : [],
  };
};
